import styled from 'styled-components';

export const StyledContainer = styled.div`
  padding: 50px 80px;
`;

export const IconCardListContainer = styled.div`
  padding: 50px;
  > div {
    justify-content: center;
  }
`;

export const SourceNameInputContainer = styled.div`
  width: 475px;
  margin: auto;
  padding: 50px 0;
  input {
    width: 100%;
  }
`;
